<template>
  <div id="edit-popup">
    <div>
      <label class="lbl"> 
        Part# <input id="part-no" v-model="partNoVal"
               v-on:keyup.enter="save"/>
      </label>
    </div>
    <div>
      <label class="lbl"> 
        Description <input id="descr" v-model="descrVal"
               v-on:keyup.enter="save" />
      </label>
    </div>
    <div>
      <label class="lbl"> 
        #Annotations <input id="aCount" v-model="aCountVal"
               v-on:keyup.enter="save" />
      </label>
    </div>
    <div>
      <button @click="cancel" class=btn> 
        Cancel
      </button>
      <button @click="save" class=btn id="save"> 
        Save
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'part-editor',

  data () {
    return {
      partNoVal:"",
      descrVal: "",
      aCountVal: '',
      part: [],
    }
  },
  props: [
    'parts',
    'selPartNo',
    'newPart',
    'lastPartNo',
  ],

  methods: {
    save () {
      this.part.partNo        = this.partNoVal;
      this.part.descr         = this.descrVal;
      this.part.annotateCount = +this.aCountVal;
      if(this.newPart) {
        if(this.$parent.partIdx(this.partNoVal) !== undefined) {
          alert('Part number already exists');
          this.partNoVal = "";
          this.descrVal  = "";
          this.$parent.showPartEditor = false;
          return;
        }
        this.parts.push(this.part);
        this.$parent.sortParts();
        this.$parent.dbAddPart(this.part);
      }
      else
        this.$parent.dbUpdatePart(this.part);
      this.$parent.selPartNo = this.partNoVal;
      this.$parent.lineClicked(this.partNoVal);
      this.partNoVal = "";
      this.descrVal  = "";
      this.$parent.showPartEditor = false;
    },
    cancel () {
      this.partNoVal = "";
      this.descrVal  = "";
      this.$parent.showPartEditor = false;
    }
  },

  mounted () {
    let idx;
    this.part = this.$parent.part(this.selPartNo);
    const noSel = !this.part;
    if(noSel) {
      if(!this.newPart) {
        this.cancel();
        console.error('no part for ' + this.selPartNo);
        return;
      }
      idx = 0;
      this.part = Object.assign({}, this.parts[0]);
      this.part.seq = this.$parent.newSeq(0, -1);
    }
    else idx = this.$parent.partIdx(this.part.partNo);
    if(this.newPart) {
      const newSeq = this.$parent.newSeq(idx, noSel ? -1 : 1);
      this.part = {
        seq: newSeq, 
        partNo: '', 
        descr: '',
      };
    }
    this.partNoVal = this.part.partNo;
    this.descrVal  = this.part.descr;
    this.aCountVal = this.part.annotateCount;
    document.getElementById('part-no').focus();
  }
}
</script>

<style scoped>

#edit-popup {
  position: absolute;
  left: 20px;
  top:  20px;
  border: 2px solid black;
  padding: 10px;
  background-color: lightgray;
  z-index: 2;
}

.lbl {
  font-weight: bold;
}
input {
    margin-top: 10px;
}
#part-no {
  width: 60px;
}
#descr {
  width: 300px;
}
.btn {
  color: white;
  background-color: blue;
  margin-top: 10px;
}
#save {
  float: right;
}

</style>
